import { render, staticRenderFns } from "./XTBlank.vue?vue&type=template&id=081e3616&scoped=true&"
import script from "./XTBlank.vue?vue&type=script&lang=js&"
export * from "./XTBlank.vue?vue&type=script&lang=js&"
import style0 from "./XTBlank.vue?vue&type=style&index=0&id=081e3616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081e3616",
  null
  
)

component.options.__file = "XTBlank.vue"
export default component.exports